/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import {
  REGISTER_USER,
  UPDATE_USER,
  UPDATE_TEL,
  UPDATE_USER_ID,
  UPDATE_NAME,
  UPDATE_NEED_TABLEWARE,
  UPDATE_DELIVERY_ADDRESS,
  UPDATE_ADDRESS,
  UPDATE_FLOOR_ROOM,
  UPDATE_COMPANY_BUILDING,
  UPDATE_DISTRICT,
  UPDATE_LAT,
  UPDATE_LNG,
  UPDATE_PASSCODE,
} from 'constants/actionType'
import user from 'services/api/user'
import * as _ from 'lodash'
import { Capacitor } from '@capacitor/core'

/**
 * Declare Variable
 */
const registerUserAction = createAction(REGISTER_USER)
const updateUserAction = createAction(UPDATE_USER)
const updateUserIdAction = createAction(UPDATE_USER_ID)
const updateTelAction = createAction(UPDATE_TEL)
const updateNameAction = createAction(UPDATE_NAME)
const updateNeedTablewareAction = createAction(UPDATE_NEED_TABLEWARE)
const updateDeliveryAddressAction = createAction(UPDATE_DELIVERY_ADDRESS)
const updateAddressAction = createAction(UPDATE_ADDRESS)
const updateFloorRoomAction = createAction(UPDATE_FLOOR_ROOM)
const updateCompanyBuildingAction = createAction(UPDATE_COMPANY_BUILDING)
const updateDistrictAction = createAction(UPDATE_DISTRICT)
const updateLatAction = createAction(UPDATE_LAT)
const updateLngAction = createAction(UPDATE_LNG)
const updateHotelPasscodeAction = createAction(UPDATE_PASSCODE)

/**
 * Export
 */
export const loginWaiter = (params) => async (dispatch) => {
  try {
    const res = await user.scopelogin(params)
    if (_.get(res, 'permissions', []).includes('waiter-login')) {
      window.localStorage.setItem('waiter-merchantUsername', params.merchantUsername)
      window.localStorage.setItem('waiter-username', params.username)
      window.localStorage.setItem('waiter-login', true)
      dispatch(registerUserAction(res))
      return Promise.resolve(res)
    } else {
      throw new Error('!permission')
    }
  } catch (error) {
    return Promise.reject(error)
  }
}

export const logout = () => async (dispatch) => {
  try {
    dispatch(registerUserAction({
      refresh: '',
      token: '',
      permissions: [],
    }))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const registerUser = (payload, hash) => async (dispatch, getState) => {
  try {
    let client = ''
    if (Capacitor.isNative && _.includes(payload, 'waiter')) {
      client = 'waiterapp'
    }
    const res = await user.register(payload, hash, client)
    dispatch(registerUserAction(res))
    return Promise.resolve(res)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const refreshUser = (token) => async (dispatch) => {
  try {
    const res = await user.refresh(token)
    dispatch(registerUserAction(res))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateAddress = address => dispatch => {
  dispatch(updateAddressAction(address))
}

export const updateFloorRoom = string => dispatch => {
  dispatch(updateFloorRoomAction(string))
}

export const updateCompanyBuilding = string => dispatch => {
  dispatch(updateCompanyBuildingAction(string))
}

export const updateDistrict = string => dispatch => {
  dispatch(updateDistrictAction(string))
}

export const updateLat = lat => dispatch => {
  dispatch(updateLatAction(lat))
}

export const updateLng = lng => dispatch => {
  dispatch(updateLngAction(lng))
}

export const updateDeliveryAddress = address => async (dispatch) => {
  try {
    dispatch(updateDeliveryAddressAction(address))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateTel = (tel) => async (dispatch) => {
  try {
    dispatch(updateTelAction(tel))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}
export const updateName = (v) => async (dispatch) => {
  try {
    dispatch(updateNameAction(v))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const createCustomer = () => async (dispatch) => {
  try {
    const customer = await user.createCustomer()
    dispatch(updateUserIdAction(customer.id))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateUser = (params) => async (dispatch) => {
  try {
    dispatch(updateUserAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateNeedTableware = (bool) => dispatch => {
  dispatch(updateNeedTablewareAction(bool))
}

export const updateHotelPasscode = (code) => dispatch => {
  dispatch(updateHotelPasscodeAction(code))
}



// WEBPACK FOOTER //
// ./src/actions/components/user.js